import React, { useState } from 'react';
import {
    Table, Button, Card, Space, Form, Input, Select, Typography, Tag, Segmented,
    Drawer, Descriptions, message
} from 'antd';
import { SearchOutlined, ReloadOutlined, ExportOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const ROLE_OPTIONS = [
    { label: '平台视角', value: 'platform' },
    { label: '企业视角', value: 'enterprise' },
];

// mock 当前企业（企业视角）
const CURRENT_ENT = { name: '汇云科技', id: 'ENT-HUIYUN-01' };

const ORDER_STATUS = {
    待支付: { color: 'default' },
    已支付: { color: 'green' },
    已退款: { color: 'default' },
    部分退款: { color: 'orange' },
};

// TODO: 联调时替换为接口数据
const ORDER_DATA = [
    {
        id: 1, orderNo: 'C20260910090149-13-888', iccid: '8986112520808012345', msisdn: '8613800001234',
        pkgName: '月享10GB流量包', entId: '0', entName: '鹤梦云平台', app: '小鹤看家',
        payChannel: '微信支付', currency: '人民币', amount: '29.00', status: '已支付',
        createTime: '2026-09-10 09:01:49', payTime: '2026-09-10 09:02:11',
        refunds: [],
    },
    {
        id: 2, orderNo: 'C20260911123000-13-901', iccid: '8986112420209812346', msisdn: '8613800002345',
        pkgName: '季度畅享30GB', entId: 'ENT-HUIYUN-01', entName: '汇云科技', app: '云视App',
        payChannel: 'Apple Pay', currency: '美元', amount: '19.90', status: '部分退款',
        createTime: '2026-09-11 12:30:00', payTime: '2026-09-11 12:30:35',
        refunds: [
            { no: 'R20260912001', channel: 'Apple Pay', currency: '美元', amount: '5.00', time: '2026-09-12 10:00:00' },
        ],
    },
    {
        id: 3, orderNo: 'C20260912084512-13-777', iccid: '8986112520808012347', msisdn: '8613800003456',
        pkgName: '季度畅享30GB', entId: 'ENT-HUIYUN-01', entName: '汇云科技', app: '云视App',
        payChannel: 'Google Pay', currency: '美元', amount: '19.90', status: '已退款',
        createTime: '2026-09-12 08:45:12', payTime: '2026-09-12 08:45:40',
        refunds: [
            { no: 'R20260912101', channel: 'Google Pay', currency: '美元', amount: '19.90', time: '2026-09-12 15:20:00' },
        ],
    },
    {
        id: 4, orderNo: 'C20260913072033-13-666', iccid: '8986112520808012348', msisdn: '8613800004567',
        pkgName: '体验1GB流量包', entId: 'ENT-XIAOHE-88', entName: '小鹤看家', app: '小鹤看家',
        payChannel: '微信支付', currency: '人民币', amount: '6.00', status: '待支付',
        createTime: '2026-09-13 07:20:33', payTime: '-',
        refunds: [],
    },
];

const OrderList = () => {
    const [mockRole, setMockRole] = useState('platform');
    const [searchForm] = Form.useForm();
    const [detail, setDetail] = useState(null);

    const isPlatform = mockRole === 'platform';
    const dataSource = isPlatform
        ? ORDER_DATA
        : ORDER_DATA.filter((d) => d.entId === CURRENT_ENT.id);

    const columns = [
        { title: '订单号', dataIndex: 'orderNo', key: 'orderNo', width: 230 },
        {
            title: '流量卡', key: 'card', width: 220,
            render: (_, r) => (
                <div>
                    <div style={{ fontFamily: 'monospace' }}>{r.iccid}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>MSISDN：{r.msisdn}</Text>
                </div>
            ),
        },
        {
            title: '套餐', key: 'pkg', width: 180,
            render: (_, r) => (
                <div>
                    <div>{r.pkgName}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>App：{r.app}</Text>
                </div>
            ),
        },
        ...(isPlatform
            ? [{
                title: '所属企业', key: 'ent', width: 180,
                render: (_, r) => (
                    <div>
                        <div>{r.entId === '0' ? '鹤梦云平台' : r.entName}</div>
                        <Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text>
                    </div>
                ),
            }]
            : []),
        {
            title: '支付信息', key: 'pay', width: 180,
            render: (_, r) => (
                <div>
                    <div>{r.payChannel}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>{r.currency} {r.amount}</Text>
                </div>
            ),
        },
        {
            title: '订单状态', dataIndex: 'status', key: 'status', width: 110,
            render: (s) => <Tag color={ORDER_STATUS[s].color}>{s}</Tag>,
        },
        { title: '下单时间', dataIndex: 'createTime', key: 'createTime', width: 180 },
        {
            title: '操作', key: 'action', fixed: 'right', width: 90,
            render: (_, r) => <Button type="link" size="small" onClick={() => setDetail(r)}>详情</Button>,
        },
    ];

    const refundColumns = [
        { title: '退款单号', dataIndex: 'no', key: 'no', width: 160 },
        { title: '退款方式', dataIndex: 'channel', key: 'channel' },
        { title: '退款币种', dataIndex: 'currency', key: 'currency', width: 100 },
        { title: '退款金额', dataIndex: 'amount', key: 'amount', width: 100 },
        { title: '退款时间', dataIndex: 'time', key: 'time', width: 180 },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: 0 }}>流量订单</Title>
                <Space size={8}>
                    <Text type="secondary" style={{ fontSize: 12 }}>mock 角色视角切换</Text>
                    <Segmented value={mockRole} onChange={setMockRole} options={ROLE_OPTIONS} />
                </Space>
            </div>

            <Card bordered={false} style={{ marginBottom: 16, borderRadius: 8 }}>
                <Form layout="inline" form={searchForm}>
                    <Form.Item name="orderNo" style={{ marginBottom: 0 }}>
                        <Input placeholder="订单号" allowClear style={{ width: 220 }} />
                    </Form.Item>
                    <Form.Item name="iccid" style={{ marginBottom: 0 }}>
                        <Input placeholder="ICCID" allowClear style={{ width: 200 }} />
                    </Form.Item>
                    <Form.Item name="status" style={{ marginBottom: 0 }}>
                        <Select
                            placeholder="订单状态" allowClear style={{ width: 160 }}
                            options={Object.keys(ORDER_STATUS).map((k) => ({ label: k, value: k }))}
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={() => message.info('查询')}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={() => searchForm.resetFields()}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>

            <Card bordered={false} style={{ borderRadius: 8 }}>
                <div style={{ marginBottom: 16 }}>
                    <Button icon={<ExportOutlined />} onClick={() => message.success('导出成功')}>导出</Button>
                </div>
                <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={dataSource}
                    scroll={{ x: 1400 }}
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                />
            </Card>

            <Drawer
                title="流量订单详情"
                width={720}
                open={!!detail}
                onClose={() => setDetail(null)}
                destroyOnClose
            >
                {detail && (
                    <>
                        <Descriptions bordered column={2} size="small">
                            <Descriptions.Item label="订单号" span={2}>{detail.orderNo}</Descriptions.Item>
                            <Descriptions.Item label="订单状态">
                                <Tag color={ORDER_STATUS[detail.status].color}>{detail.status}</Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="所属企业">
                                {detail.entId === '0' ? '鹤梦云平台' : detail.entName}{detail.entId === '0' ? '' : `（${detail.entId}）`}
                            </Descriptions.Item>
                            <Descriptions.Item label="流量卡 ICCID">{detail.iccid}</Descriptions.Item>
                            <Descriptions.Item label="MSISDN">{detail.msisdn}</Descriptions.Item>
                            <Descriptions.Item label="套餐">{detail.pkgName}</Descriptions.Item>
                            <Descriptions.Item label="投放 App">{detail.app}</Descriptions.Item>
                            <Descriptions.Item label="支付方式">{detail.payChannel}</Descriptions.Item>
                            <Descriptions.Item label="支付金额">{detail.currency} {detail.amount}</Descriptions.Item>
                            <Descriptions.Item label="下单时间">{detail.createTime}</Descriptions.Item>
                            <Descriptions.Item label="支付时间">{detail.payTime}</Descriptions.Item>
                        </Descriptions>

                        <div style={{ margin: '24px 0 12px', fontWeight: 500 }}>退款单</div>
                        <Table
                            rowKey="no"
                            size="small"
                            columns={refundColumns}
                            dataSource={detail.refunds}
                            pagination={false}
                            locale={{ emptyText: '暂无退款单' }}
                        />
                        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 8 }}>
                            退款由 C 端发起并经 API 同步，后台仅保留并展示退款单。
                        </Text>
                    </>
                )}
            </Drawer>
        </div>
    );
};

export default OrderList;
